<template>
  <div id="app">
    <loading :active.sync="isLoading"></loading>
    <Navbar v-if="authorized && $route.name !== 'Biztalk'&& !shouldHideHeader" />
    <main>
      <router-view style="min-height: 50vh;" :idleTime="count" v-on:isIdle="checkIdle" :key="!forceRemountRoutes.includes($route.name) ? $route.fullPath : null" :class="{'main-info':authorized && !shouldHideHeader }"/>
    </main>
    <Footer v-if="$route.name !== 'Mag' && $route.name !== 'Biztalk' && !shouldHideHeader" />
    <Announcement v-if="authorized && !isHide && magEnable === false && !shouldHideHeader"/>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import Announcement from '@/components/Announcement.vue'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'App',
  data () {
    return {
      // isLoading: true,
      autoLogout: 30,
      count: 0,
      forceRemountRoutes: ['ai_assistantIntro', 'ai_assistantMain', 'ai_assistant_correction', 'ai_assistant_follow', 'viewGenerate', 'chat', 'chat_history', 'viewChat', 'conversation_rating', 'records']
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'authorized',
      'authInfo'
    ]),
    shouldHideHeader() {
      return this.$route.matched.some(r => r.meta.hideHeader)
    },
    magOnly () {
      if(this.authInfo.user.magOnly === true) {
        return true
      } else {
        return false
      }
    },
    magEnable () {
      if(this.authInfo.user.magEnable === true) {
        return true
      } else {
        return false
      }
    },
    isHide () {
      let arr = ['CourseLesson', 'chat', 'ai_assistantIntro', 'ai_assistantMain', 'chat_history', 'conversation_rating', 'ai_assistant_correction', 'ai_assistant_follow']

      if (arr.indexOf(this.$route.name) > -1) {
        return true
      }
      // return this.$route.name === 'CourseLesson'
    }
  },
  components: {
    Navbar,
    Loading,
    Footer,
    Announcement
  },
  beforeDestroy () {
    document.removeEventListener('pointerdown', this.showLaserPointerEffect, true)
    this.clearTimer()
  },
  mounted () {
    this.$gtm.enabled()
    document.addEventListener('pointerdown', this.showLaserPointerEffect, true)
    document.onmousemove = (event) => {
      let x1 = event.clientX
      let y1 = event.clientY
      if (this.x !== x1 || this.y !== y1) {
        this.count = 0
      }
      this.x = x1
      this.y = y1
    }
    document.onkeydown = () => {
      this.count = 0
    }
    document.onscroll = () => {
      this.count = 0
    }
    this.setTimer()
  },
  methods: {
    ...mapActions({
      dologout: 'logout'
    }),
    clearTimer () {
      clearInterval(window.myTimer)
      window.myTimer = null
    },
    setTimer () {
      this.count = 0
      if (!window.myTimer) {
        window.myTimer = window.setInterval(this.cookieTimeout, 1000)
      }
    },
    cookieTimeout () {
      let outTime = this.autoLogout
      this.count++
      if (this.count === outTime * 60) {

      }
      if (this.count === outTime * 60) {
        setTimeout(this.logout, 10000)
      }
    },
    logout () {
      if (this.count >= this.autoLogout * 30) {
        if (this.magOnly) {
          this.$router.push({ name: 'Mag' })
        } else {
          this.$router.push({ name: 'Login' })
        }
        this.$swal({
          title: '您已閒置30分鐘，已被登出',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: '確定',
          customClass: {
            confirmButton: 'btn btn-danger'
          }
        })
        this.dologout()
      }
    },
    checkIdle (val) {
      if (val === 'playing') {
        this.clearTimer()
      } else {
        this.setTimer()
      }
    },
    showLaserPointerEffect (event) {
      if (!document.body.classList.contains('class04')) {
        return
      }
      if (event.button && event.button !== 0) {
        return
      }

      const effect = document.createElement('span')
      effect.className = 'laser-pointer-effect'
      effect.style.left = `${event.clientX}px`
      effect.style.top = `${event.clientY}px`
      effect.innerHTML = '<span></span>'
      document.body.appendChild(effect)

      effect.addEventListener('animationend', () => {
        effect.remove()
      })
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: Avenir, Helvetica, Arial, sans-serif, 微軟正黑體;
  box-sizing: border-box;
}
#app {
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
main {
  flex: 1; /* 讓 main 撐開剩餘高度 */
}
.main-info {
  margin: 93px 0 0 0;
  min-height: calc(100vh - 93px);
}
.btn-general {
  border-radius: 20px !important;
  width: 150px;
}
input:focus {
  outline: none;
}

.success {
  font-size: 1.5rem;
  margin-top: 60px;
}
.error {
  text-align: left;
  color: red;
  font-size: .8rem;
}
.laser-pointer-effect {
  position: fixed;
  z-index: 2147483647;
  top: 0;
  left: 0;
  width: 96px;
  height: 96px;
  pointer-events: none;
  transform: translate(-50%, -50%);
}
.laser-pointer-effect,
.laser-pointer-effect::before,
.laser-pointer-effect::after,
.laser-pointer-effect span {
  animation-duration: .58s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
}
.laser-pointer-effect::before {
  content: "";
  position: absolute;
  inset: 27px;
  border: 2px solid rgba(255, 20, 20, .95);
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(255, 0, 0, .95), 0 0 22px rgba(255, 0, 0, .45);
  animation-name: laserRing;
}
.laser-pointer-effect::after {
  content: "";
  position: absolute;
  left: 46px;
  top: -9px;
  width: 4px;
  height: 54px;
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0), #fff 20%, #ff1d1d 45%, rgba(255, 0, 0, 0));
  box-shadow: 0 0 8px rgba(255, 0, 0, .95), 0 0 18px rgba(255, 0, 0, .55);
  transform: rotate(38deg);
  transform-origin: 50% 100%;
  animation-name: laserBeam;
}
.laser-pointer-effect span {
  position: absolute;
  left: 42px;
  top: 42px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ff1d1d;
  box-shadow: 0 0 6px #fff, 0 0 14px rgba(255, 0, 0, .95), 0 0 28px rgba(255, 0, 0, .7);
  animation-name: laserDot;
}
@keyframes laserRing {
  0% {
    opacity: 1;
    transform: scale(.25);
  }
  100% {
    opacity: 0;
    transform: scale(1.75);
  }
}
@keyframes laserBeam {
  0% {
    opacity: 0;
    transform: rotate(38deg) scaleY(.2);
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(38deg) scaleY(1.15) translateY(-10px);
  }
}
@keyframes laserDot {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(.45);
  }
}
::placeholder {
  color: rgb(165, 165, 165);
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: rgb(165, 165, 165);
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: rgb(165, 165, 165);
}
/*@media screen and (max-width: 450px) {
	.main-info {
    margin: 110px 0 0 0;
  }
}*/
</style>
